var text_field_default = {
  "root": "Ob4iU",
  "text": "NRf9r",
  "input": "CDl6n",
  "small": "_6fUpR",
  "medium": "JKOgl",
  "large": "c-c5b",
  "webview": "_5PTQQ",
  "endAdornment": "XbGYU",
  "shown": "_7WKAk",
  "value": "qilOy",
  "spinner": "Oycqd",
  "spin": "KhOpy"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
